import { s as subscribe } from "../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component, e as escape, m as missing_component } from "../../chunks/ssr.js";
import { p as page } from "../../chunks/stores.js";
import { u as user } from "../../chunks/auth.js";
import { B as Button } from "../../chunks/Button.js";
import { M as Modal } from "../../chunks/Modal2.js";
import { g as globalConfirm } from "../../chunks/modal.js";
import { f as fly } from "../../chunks/TransitionFrame.js";
import { T as Toast } from "../../chunks/Toast.js";
import { g as globalToast } from "../../chunks/toast2.js";
const GlobalConfirmation = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $globalConfirm, $$unsubscribe_globalConfirm;
  $$unsubscribe_globalConfirm = subscribe(globalConfirm, (value) => $globalConfirm = value);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Modal, "Modal").$$render(
      $$result,
      { open: $globalConfirm.open },
      {
        open: ($$value) => {
          $globalConfirm.open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<p>${escape($globalConfirm.content)}</p> <div class="grid grid-cols-2 gap-12 mt-3">${validate_component(Button, "Button").$$render($$result, { color: "red" }, {}, {
            default: () => {
              return `Nein`;
            }
          })} ${validate_component(Button, "Button").$$render($$result, { color: "green" }, {}, {
            default: () => {
              return `Ja`;
            }
          })}</div>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_globalConfirm();
  return $$rendered;
});
const GlobalToast = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $globalToast, $$unsubscribe_globalToast;
  $$unsubscribe_globalToast = subscribe(globalToast, (value) => $globalToast = value);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `${validate_component(Toast, "Toast").$$render(
      $$result,
      {
        dismissable: true,
        color: $globalToast.color,
        position: "top-right",
        class: "z-50",
        transition: fly,
        open: $globalToast.open
      },
      {
        open: ($$value) => {
          $globalToast.open = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `<div class="flex gap-3">${$globalToast.icon ? `${validate_component($globalToast.icon || missing_component, "svelte:component").$$render($$result, {}, {}, {})}` : ``} <div>${escape($globalToast.content)}</div></div>`;
        }
      }
    )}`;
  } while (!$$settled);
  $$unsubscribe_globalToast();
  return $$rendered;
});
const Layout = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => value);
  user.subscribe((val) => {
  });
  $$unsubscribe_page();
  return `${validate_component(GlobalToast, "GlobalToast").$$render($$result, {}, {}, {})} ${validate_component(GlobalConfirmation, "GlobalConfirmation").$$render($$result, {}, {}, {})} ${slots.default ? slots.default({}) : ``}`;
});
export {
  Layout as default
};
//# sourceMappingURL=_layout.svelte.js.map
